import { Typography } from '@packages/ui/shared';
import { useTranslation } from 'react-i18next';

import { DECISION_MODAL_WIDTH } from '../ssm5.constants';
import { ssm5TextStyles } from '../ssm5.styles';
import { Ssm5Modal } from './ssm5-modal';

/** Props for {@link Ssm5SlowConnectionModal}. */
export type Ssm5SlowConnectionModalProps = {
    /** Called when the technician lets the attempt run on. */
    onKeepWaiting: () => void;
    /** Called when the technician restarts the pairing through the same Cloud Connector ID. */
    onRestart: () => void;
    /** Whether the modal is visible. */
    show: boolean;
};

/**
 * Modal telling the technician that connecting the vehicle is taking longer than expected, and letting
 * them keep waiting or restart the pairing.
 *
 * @param props - {@link Ssm5SlowConnectionModalProps}
 * @returns the modal
 */
export function Ssm5SlowConnectionModal({ onKeepWaiting, onRestart, show }: Ssm5SlowConnectionModalProps) {
    const { t } = useTranslation();

    const actions = {
        primary: { onPress: onRestart, title: t('ssm5:slowConnection.tryAgain') },
        secondary: { onPress: onKeepWaiting, title: t('ssm5:slowConnection.keepWaiting') },
    };

    return (
        <Ssm5Modal
            actions={actions}
            look="card"
            onHide={onKeepWaiting}
            show={show}
            title={t('ssm5:slowConnection.title')}
            width={DECISION_MODAL_WIDTH}
        >
            <Typography style={ssm5TextStyles.body} variant="default">
                {t('ssm5:slowConnection.description')}
            </Typography>
        </Ssm5Modal>
    );
}
